module.exports = __webpack_public_path__ + "static/media/d3.02fe5fca.png";